<!-- Not using nz-collapse as it changed state when changing the sorting -->
<div class="flex flex-col border-1 border-solid border-primary-border rounded-md pointer-events-auto">
  <div class="flex flex-col gap-4 pl-12 pt-12 pr-16 pb-4" (click)="toggleCollapse()">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-8 pt-2">
        <twaice-fe-svg-icon class="mr-8" [name]="!showDetails() ? 'chevron-right' : 'chevron-down'" source="tabler" size="16px" />

        <twaice-fe-svg-icon
          [name]="alertIconConfig[rule.highestSeverity].iconName"
          source="tabler"
          [fill]="alertIconConfig[rule.highestSeverity].fillColor"
          [color]="alertIconConfig[rule.highestSeverity].edgeColor"
          size="16px"
        />
        <p class="font-bold mb-0 text-base leading-[1] pr-8" [ngClass]="{ 'border-r-1': rule.type !== ruleType.BMSRule }">
          {{ rule.ruleName }}
        </p>

        <div class="flex gap-4 items-center mb-0 text-primary-text text-base leading-[1] whitespace-nowrap">
          <span>{{ getBreachValueLabel(rule) }}</span>
          <div class="text-secondary-text" *ngIf="rule.type !== ruleType.BMSRule && rule.isBreachOnOldVersion">
            <twaice-fe-svg-icon
              nz-tooltip
              nzTooltipTitle="Thresholds were updated on this day. The breached value may not match the current settings"
              source="tabler"
              name="info-circle"
              size="16px"
            />
          </div>
        </div>
        @if (rule.isOngoing) {
          @if (isHistoricBreach$ | async) {
            <div class="text-sm whitespace-nowrap">
              Not cleared on {{ (selectedDate$ | async)! | date: 'MMM dd, yyyy' : '+0000' }}
            </div>
          } @else {
            <nz-tag
              class="flex items-center gap-8 m-0"
              [ngStyle]="{ color: ongoingTagTextColor }"
              [nzColor]="ongoingTagFillColor"
            >
              <twaice-fe-svg-icon name="circle-filled" source="tabler" [color]="ongoingCircleFillColor" size="8px" />
              <span>Ongoing</span>
            </nz-tag>
          }
        } @else {
          <nz-tag class="m-0" [ngStyle]="{ color: clearedTagTextColor }" [nzColor]="clearedTagFillColor">Cleared</nz-tag>
        }
      </div>
    </div>
    <div class="flex justify-end mr-8">
      <p class="text-tertiary-text text-sm mb-0">
        Last {{ rule.type === ruleType.BMSRule ? 'alert' : 'breach' }}: {{ getLastBreachTimestampLabel(rule) }}
      </p>
    </div>
  </div>
  <nz-divider class="m-0" />
  <twaice-fe-component-rule-breach-details *ngIf="showDetails()" [rule]="rule" />
</div>
